import { PAGE_URLS } from '../../../constants/hrefLinks'
import './style.scss'

interface InstructorNameProps {
	name: string
}

function InstructorName({name}: InstructorNameProps) {

	return (
		<div className="instructor-name-wrap">
			<a
				href={PAGE_URLS.SEARCH}
			>
				<img
					className="instructor-name-back-button"
					src={`/imgs/icons/icon-arrow-left.svg`}
					alt="Back arrow icon"
				/>
			</a>
			<div className="instructor-name-txt">{name}</div>
		</div>
	)
}

export default InstructorName